//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import _ from 'lodash';

export default {
  name: 'SandBoxTemplateCreate',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    provider: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        provider_name: '',
        model_name: '',
        model_type: '',
      },
      modelTypeOptions: [
        {
          label: 'llm',
          value: 'llm',
        },
        {
          label: 'text-embedding',
          value: 'text-embedding',
        },
        {
          label: 'rerank',
          value: 'rerank',
        },
        {
          label: 'speech2text',
          value: 'speech2text',
        },
        {
          label: 'tts',
          value: 'tts',
        },
      ],
      modelUseOptions: [
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        },
      ],
      rules: {
        provider_name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
      },
      checked: false,
      showJson: false,
    };
  },
  watch: {
    visible() {
      // this.row
      console.log('%c Line:102 🌽 this.row', 'color:#e41a6a', this.row);
      if (this.visible) {
        if (this.operateType === 'add') {
          this.form = {
            provider_name: '',
            credentials: '{}',
          };
        } else {
          this.form = _.cloneDeep(this.row);
        }
        this.$refs.form.resetFields();
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
    openJsonEdit() {
      this.showJson = true;
    },
    saveJson(json) {
      this.form.credentials = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    createModel() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // this.form
          console.log('%c Line:122 🥝 this.form', 'color:#ed9ec7', this.form);
          if (this.operateType === 'add') {
            const params = {
              provider_name: this.provider,
              model_name: this.form.model_name,
              model_type: this.form.model_type,
            };
            this.$request({
              url: this.$api.aiAddModel,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          } else {
            const params = {
              provider_name: this.provider,
              model_name: this.form.model_name,
              enabled: this.form.enabled,
            };
            // params
            console.log('%c Line:209 🍖 params', 'color:#ed9ec7', params);
            this.$request({
              url: this.$api.aiUpdateModel,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          }
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
